var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useCallback } from "react";
import { useHistory } from "../config/hooks";
import { Typography } from "../typography";
import { createNativeElement } from "../utils/element";
const Link = forwardRef((_a, ref) => {
    var { to, disabled, textVariant = "inherit", type: _ } = _a, props = __rest(_a, ["to", "disabled", "textVariant", "type"]);
    const { onClick } = props; // This way onClick is not removed from props
    const history = useHistory();
    const preventClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const redirect = useCallback((e) => {
        if (onClick) {
            onClick(e);
        }
        if (to) {
            e.preventDefault();
            if (e.metaKey || e.altKey) {
                window.open(to);
            }
            else if (history) {
                history.push(to);
            }
        }
    }, [to, history, onClick]);
    if (disabled) {
        props.onMouseDownCapture = preventClick;
        props.onMouseUpCapture = preventClick;
        props.onClickCapture = preventClick;
        props["aria-disabled"] = "true";
        props.tabIndex = -1;
    }
    if (history && to) {
        props.onClick = redirect;
        props.href = to;
    }
    else if (to) {
        props.href = to;
    }
    return textVariant === "inherit" ? (createNativeElement("a", props, ref)) : (React.createElement(Typography, Object.assign({ component: "a" }, props, { variant: textVariant, ref: ref })));
});
export default Link;
